import { MAP_API_KEY } from '@/config';

let mapsLoaderPromise = null;

function hasGoogleMaps() {
  const g = window.google;
  return (
    g &&
    g.maps &&
    typeof g.maps.Map === 'function' &&
    typeof g.maps.StyledMapType === 'function'
  );
}

export function loadGoogleMaps() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Google Maps can only load in the browser'));
  }

  if (hasGoogleMaps()) {
    return Promise.resolve(window.google);
  }

  if (mapsLoaderPromise) {
    return mapsLoaderPromise;
  }

  mapsLoaderPromise = new Promise((resolve, reject) => {
    const callbackName = `__redbookMapsReady_${Date.now()}`;

    window[callbackName] = () => {
      delete window[callbackName];
      resolve(window.google);
    };

    const script = document.createElement('script');
    script.async = true;
    script.defer = true;

    const params = new URLSearchParams({
      key: MAP_API_KEY,
      loading: 'async',
      callback: callbackName,
    });

    script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
    script.onerror = () => {
      delete window[callbackName];
      mapsLoaderPromise = null;
      reject(new Error('Failed to load Google Maps'));
    };

    document.head.appendChild(script);
  });

  return mapsLoaderPromise;
}
